import React from 'react';

import './progress-bar.css';

class ProgressBar extends React.Component {

    render() {
        const { progress = 0 } = this.props;
        return (
            <div className='progress-wrapper'>
                <div className='progress-mark' style={{ width: `${progress}%` }}/>
                <span className={`${progress > 55 ? 'half-filled' : ''}`}>{`${progress}%`}</span>
            </div>
        );
    }
}

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/progress-bar/progress-bar.js